import { refreshTable } from '@packages/table-builder';
import { queryClient } from '@/queryClient';

export const TAX_SETUP_TABLE_ENTITY = 'tax-setup';

/** Infinite-scroll V2 table + legacy list cache (modals and row actions). */
export function refreshTaxSetupTable(registryRefresh?: () => void): void {
  registryRefresh?.();
  refreshTable(TAX_SETUP_TABLE_ENTITY);
  void queryClient.invalidateQueries('dt-v2-page');
  void queryClient.invalidateQueries('getTaxSetupList');
}
